import * as yup from 'yup';
import { normaliseHiddenTools } from '../clientTools';

/**
 * E57 · SetHiddenTools — the both-ends input codec of `setHiddenTools` (plan 03 §2.1 #4): the portal's My tools page
 * (before it saves) and — as the shield's inputRule — the API run the SAME schema. The board: "A tool key the
 * catalogue does not know is dropped by the validator at the edge" — the transform keeps the catalogue's keys only,
 * once each, in the canonical order (`normaliseHiddenTools`); a generous cap stops abuse. `performer` is never on the
 * wire (the signed-in therapist).
 */
export const setHiddenToolsInputSchema: yup.AnyObjectSchema = yup.object({
  hiddenTools: yup
    .array()
    .of(yup.string().trim().max(64).required())
    .max(64)
    .transform((value: unknown) =>
      Array.isArray(value) ? normaliseHiddenTools(value) : value,
    )
    .required(),
});

/** The mutation ARGUMENTS — what the shield's inputRule validates. */
export const setHiddenToolsArgsSchema: yup.AnyObjectSchema = yup.object({
  input: setHiddenToolsInputSchema.required(),
});

export const clientManagementValidators = {
  setHiddenToolsInputSchema,
  setHiddenToolsArgsSchema,
};
